import Excel from "exceljs"
import { saveAs } from "file-saver"
import { exportFileName } from "../../../../../../../../../utils/exportFileName"
import { convertDataExportExcel } from "./convertDataExport"
import { cellConfig } from "./cellConfig"
import { columnsConfig } from "./columnsConfig"
import { Translate } from "../../../../../../../../../constant/Translate"
import { SchedulesExportFRM103ResType } from "../../../../../../models/list/export"

const { EXPORT_EP0237 } = Translate

export const exportExcelFRM103 = async (
  dataSource: SchedulesExportFRM103ResType[],
) => {
  const workbook = new Excel.Workbook()

  const fullNameRomaji = "Sheet1"
  const worksheet = workbook.addWorksheet(fullNameRomaji)
  const convertData = convertDataExportExcel(dataSource)

  columnsConfig(worksheet)

  convertData.forEach((itemRow) => {
    worksheet.addRow(itemRow)
  })

  cellConfig(worksheet)

  const buffer = await workbook.xlsx.writeBuffer()
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  const fileExtension = ".xlsx"

  const blob = new Blob([buffer], { type: fileType })

  saveAs(blob, exportFileName(EXPORT_EP0237) + fileExtension)
}
